import script from "./StaffSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffSettings.vue?vue&type=script&setup=true&lang=js"

import "./StaffSettings.vue?vue&type=style&index=0&id=705ee7c3&lang=scss"
import "./StaffSettings.vue?vue&type=style&index=1&id=705ee7c3&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-705ee7c3"]])

export default __exports__